/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { createReducer, AnyAction } from "@reduxjs/toolkit";
import initStates from "./initStates";
import { PushsState } from "./reducerStateInterface";
import { PUSHS_GET_REQUEST_ACTION, PUSHS_GET_SUCCESS_ACTION, PUSHS_GET_ERROR_ACTION } from "../actions/pushs";

/**
 * User reducer
 * handles states used by user related components
 * @param state State object managed by user reducer
 * @param action The dispatched action
 */
const pushsReducer = createReducer(initStates.pushs, (builder) => {
  builder.addCase(PUSHS_GET_REQUEST_ACTION, (state: PushsState, action: AnyAction) => {
    state.isLoading = true;
  });

  builder.addCase(PUSHS_GET_SUCCESS_ACTION, (state: PushsState, action: AnyAction) => {
    state.pushs = action.payload.pushsData;
    state.isLoading = false;
  });

  builder.addCase(PUSHS_GET_ERROR_ACTION, (state: PushsState, action: AnyAction) => {
    state.isLoading = false;
  });
});

export default pushsReducer;
